import React from 'react';

import type { BlockStimulus } from '@interactive-room';

import { inferStimulusIconKey, resolveStimulusTheme } from '@interactive-room';

import { StimulusThemeIcon } from './StimulusThemeIcon';

import { PrintThemedReading } from './PrintThemedReading';

import { PrintContextImage } from './PrintContextImage';

interface PrintStimulusWrapperProps {
  stimulus?: BlockStimulus | null;
  children: React.ReactNode;
}

export function PrintStimulusWrapper({ stimulus, children }: PrintStimulusWrapperProps) {
  if (!stimulus?.content?.trim()) return <>{children}</>;

  const theme = resolveStimulusTheme(stimulus);
  const icon = inferStimulusIconKey(stimulus.content, stimulus.title ?? '');
  const isThemed = theme !== 'prose';
  const imageUrl = stimulus.imageUrl;

  return (
    <div className="print-stimulus-wrap print:break-inside-avoid">
      <aside className={`print-stimulus print-stimulus--${theme}`}>
        {isThemed ? <StimulusThemeIcon icon={icon} /> : null}
        <div
          className={`print-stimulus__content${imageUrl ? ' print-stimulus__content--with-image' : ''}`}
        >
          {imageUrl ? (
            <PrintContextImage imageUrl={imageUrl} alt={stimulus.title} themed float />
          ) : null}
          <PrintThemedReading theme={theme} title={stimulus.title} content={stimulus.content} />
        </div>
      </aside>
      <div className="print-stimulus__exercise">{children}</div>
    </div>
  );
}
